export default __webpack_public_path__ + "static/media/microchip.697194c4.png";